export default __webpack_public_path__ + "static/media/olhoaberto.4569d374.svg";